module.exports = __webpack_public_path__ + "static/media/storyteller-logo-black.fcf47b9d.svg";